import React from "react";

class ProgressBarComponent extends React.Component {

    static defaultProps = {
        progressBarSet: { label: '', percent: '0' }
    };

    render() {
        let { progressBarSet } = this.props;
        let _style = { width: progressBarSet.percent + '%' };
        let _bcSettings = progressBarSet.label.split(' -> ');
        return (
            <div>
                {/* <h6>{progressBarSet.label}</h6> */}
                <nav aria-label="breadcrumb">
                    <ol className='breadcrumb'>
                        {_bcSettings.map( (element, index) => {
                            let _classIndex = 'breadcrumb-item ' + ((index === (_bcSettings.length -1)) ? 'text-primary' : 'text-dark');
                            return (<li key={index} className={_classIndex}>{element}</li>)
                        })
                        }
                    </ol>
                </nav>
                <div className='progress'>
                    <div className="progress-bar" role='progressbar' aria-valuenow={progressBarSet.percent}
                        style={_style}
                        aria-valuemin='0' aria-valuemax='100'>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProgressBarComponent;



